<template>
  <ul class="activity-timeline vx-timeline">
      <li v-for="(log, index) in activityLogData" :key="index">
          <div class="timeline-icon p-0">
              <vs-avatar
                v-if="log && log.userData && log.userData.profilePictureUrl"
                size="32px"
                :src="
                  constants.s3Bucket +
                  '/editor/profile-pictures/' + 
                  log.userData.profilePictureUrl
                "
              />
              <vs-avatar
                v-else
                size="32px"
                
              :src="require('@/assets/images/temp-img/temp-boringavatar.png')"
              />
          </div>
          <div v-if="log" class="timeline-info items-left">
              <p v-if="log" class="font-semibold">{{ log.userData.firstName }} {{ log.userData.lastName }}</p>
              <span v-if="log" class="activity-desc">{{ log.logText }}</span>
          </div>
          <div v-else class="timeline-info items-left">
              <p class="font-semibold"></p>
              <span class="activity-desc"></span>
          </div>
          <!-- <small class="text-grey activity-e-time">{{ item.time }}</small> -->
      </li>
  </ul>
</template>

<script>
import constants from "@/constants.js";

export default {
  name: "vx-timeline",
  props: {
    // data: {
    //   type: Array,
    //   required: true
    // }
    activityLogData: {
        type: Array,
        required: true,
        default: () => { return []; }
    }
  },
  data() {
    return {
      constants,
      activityLog: []
    }
  },
  computed: {
      orgData() {
          return this.$store.state.organization.orgData;
      }
  },
}
</script>

<style scoped lang="scss">
@import "@/assets/scss/vuexy/components/vxTimeline.scss";

.activity-timeline.vx-timeline {
  border-left: none!important;
  padding-left: 40px!important;
}
</style>
